/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TenantSecuritySettingsDto
 */
export interface TenantSecuritySettingsDto {
    /**
     * 
     * @type {boolean}
     * @memberof TenantSecuritySettingsDto
     */
    useDefaultPasswordComplexity?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSecuritySettingsDto
     */
    requireDigit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSecuritySettingsDto
     */
    requireLowercase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSecuritySettingsDto
     */
    requireNonAlphanumeric?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSecuritySettingsDto
     */
    requireUppercase?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantSecuritySettingsDto
     */
    requiredLength?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TenantSecuritySettingsDto
     */
    enableUserLockout?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TenantSecuritySettingsDto
     */
    maxLockoutNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantSecuritySettingsDto
     */
    accountLockingDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof TenantSecuritySettingsDto
     */
    autoLogoutAfterInactiveSeconds?: number;
    /**
     * 
     * @type {string}
     * @memberof TenantSecuritySettingsDto
     */
    $type?: TenantSecuritySettingsDtoTypeEnum;
}


/**
 * @export
 */
export const TenantSecuritySettingsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMultiTenancyDtoTenantSecuritySettingsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MultiTenancy.Dto.TenantSecuritySettingsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TenantSecuritySettingsDtoTypeEnum = typeof TenantSecuritySettingsDtoTypeEnum[keyof typeof TenantSecuritySettingsDtoTypeEnum];



/**
 * Check if a given object implements the TenantSecuritySettingsDto interface.
 */
export function instanceOfTenantSecuritySettingsDto(value?: unknown): value is TenantSecuritySettingsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TenantSecuritySettingsDtoTypeEnum)[0];
}

export function TenantSecuritySettingsDtoFromJSON(json: any): TenantSecuritySettingsDto {
    return TenantSecuritySettingsDtoFromJSONTyped(json, false);
}

export function TenantSecuritySettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSecuritySettingsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'useDefaultPasswordComplexity': json['useDefaultPasswordComplexity'] == null ? undefined : json['useDefaultPasswordComplexity'],
        'requireDigit': json['requireDigit'] == null ? undefined : json['requireDigit'],
        'requireLowercase': json['requireLowercase'] == null ? undefined : json['requireLowercase'],
        'requireNonAlphanumeric': json['requireNonAlphanumeric'] == null ? undefined : json['requireNonAlphanumeric'],
        'requireUppercase': json['requireUppercase'] == null ? undefined : json['requireUppercase'],
        'requiredLength': json['requiredLength'] == null ? undefined : json['requiredLength'],
        'enableUserLockout': json['enableUserLockout'] == null ? undefined : json['enableUserLockout'],
        'maxLockoutNumber': json['maxLockoutNumber'] == null ? undefined : json['maxLockoutNumber'],
        'accountLockingDuration': json['accountLockingDuration'] == null ? undefined : json['accountLockingDuration'],
        'autoLogoutAfterInactiveSeconds': json['autoLogoutAfterInactiveSeconds'] == null ? undefined : json['autoLogoutAfterInactiveSeconds'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TenantSecuritySettingsDtoToJSON(value?: TenantSecuritySettingsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'useDefaultPasswordComplexity': value['useDefaultPasswordComplexity'],
        'requireDigit': value['requireDigit'],
        'requireLowercase': value['requireLowercase'],
        'requireNonAlphanumeric': value['requireNonAlphanumeric'],
        'requireUppercase': value['requireUppercase'],
        'requiredLength': value['requiredLength'],
        'enableUserLockout': value['enableUserLockout'],
        'maxLockoutNumber': value['maxLockoutNumber'],
        'accountLockingDuration': value['accountLockingDuration'],
        'autoLogoutAfterInactiveSeconds': value['autoLogoutAfterInactiveSeconds'],
        '$type': value['$type'],
    });
}

